"use client";

import { LinkButton } from "@/components/links/LinkButton";
import { NumericProgress } from "@/components/ui/progress/NumericProgress";
import { ProgressBar } from "@/components/ui/progress/ProgressBar";
import { ProgressStatus } from "@/components/ui/progress/ProgressStatus";
import { ConversionConstructedNoDates } from "@/types/types";

export function NotDoneConversionMulti({
  conversionMulti,
  open,
  setOpen,
}: {
  conversionMulti: ConversionConstructedNoDates[];
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const percentagesDone = conversionMulti.map(
    (conversion) => conversion.percentageDone
  );

  // Get the lowest percentage done
  const percentageDoneMin = Math.min(...percentagesDone);
  const hasProgress = percentageDoneMin > 10;
  const conversionsAmount = conversionMulti.length;
  return (
    <div className="flex h-full flex-col justify-between">
      <div>
        <div className="flex flex-row items-center gap-x-3">
          <LinkButton onClick={() => setOpen((prevOpen) => !prevOpen)}>
            {open ? "Less" : "More"}
          </LinkButton>
          <ProgressBar progress={percentageDoneMin} />
          <NumericProgress progress={percentageDoneMin} />
        </div>
      </div>
      <div className="mt-4">
        <ProgressStatus
          processType={
            hasProgress ? `Converting ${conversionsAmount} files` : "Starting"
          }
        />
      </div>
    </div>
  );
}
